import classnames from 'classnames'

const cx = classnames

export default cx
